import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const exchange = async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        navigate("/admin", { state: { user: res.data }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-champagne border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
